var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"fa-icon",attrs:{"viewBox":_vm.viewBox,"width":_vm.sizePx,"height":_vm.sizePx,"fill":"currentColor","aria-hidden":"true","focusable":"false"}},_vm._l((_vm.paths),function(d,i){return _c('path',{key:i,attrs:{"d":d}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }